import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const galleryImages = [
  '/images/Ratones1.jpg',
  '/images/Ratones2.jpg',
  '/images/Ratones3.jpg',
  '/images/Ratones4.jpg'
];

const Ratones = () => {
  const [images, setImages] = useState(galleryImages);

  // Rotar las imágenes cada 4 segundos
  useEffect(() => {
    const interval = setInterval(() => {
      setImages((prev) => {
        const [first, ...rest] = prev;
        return [...rest, first]; // mueve la primera al final
      });
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="py-20 bg-gradient-to-br from-purple-50 to-pink-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.h2
          className="text-4xl font-bold text-center text-gray-800 mb-12 bg-gradient-to-r from-purple-500 to-pink-600 bg-clip-text text-transparent"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          Quiénes Somos
        </motion.h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <AnimatePresence>
            {images.map((src, index) => (
              <motion.div
                key={src}
                className="relative overflow-hidden rounded-3xl shadow-xl"
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.6 }}
              >
                <img
                  src={src}
                  alt={`Ratón ${index + 1}`}
                  className="w-full h-64 object-cover transition-transform duration-500 hover:scale-105"
                />
              </motion.div>
            ))}
          </AnimatePresence>
        </div>
      </div>
    </section>
  );
};

export default Ratones;
